import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import './MessagingWindow.scss'
import HrbLogoSquare from '../../../../components/library/graphics/HrbLogoSquare'
import UserMessageIcon from '../../../../components/library/graphics/UserMessageIcon'
import HrbTranslate from '../../../../components/language/HrbTranslate'
import DateTime from '../../../../components/library/common/DateTime'
import DOMPurify from 'dompurify'

const Message = props => {
    const { loaded, message, senderName, isClientMessage } = props

    let style = !loaded ? { height: isClientMessage ? 110 : 140 } : {}

    return (
        <div className='message-container columns' style={style}>
            {loaded &&
                <div id={`message-${message.id}`}
                    className={classnames('message column is-offset-1 is-10',
                        { 'sent': !isClientMessage && loaded },
                        { 'received': isClientMessage && loaded },
                        { 'unread': !message.isRead && loaded })}>
                    <div className='message-info-header mb-3'>
                        <div className='sender-icon mr-1'>
                            {isClientMessage ? <UserMessageIcon /> : <HrbLogoSquare colour='green' />}
                        </div>
                        <span className={isClientMessage ? 'client-align' : 'pro-align'}>
                        <HrbTranslate text='Messages.SentFrom' className='ml-2' params={
                            {
                                date: <DateTime value={message.modifiedTime || message.creationTime} dateAndTime />,
                                name: senderName
                            }} />
                        </span>
                    </div>
                    <div
                        className='message-content'
                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(message.messageContent, { ADD_ATTR: ['target'] }) }} />
                </div>
            }
            {!loaded && isClientMessage &&
                <div className='column is-offset-2 is-8'>
                    <div className='skeleton' style={{
                        width: '100%',
                        height: 160,
                        marginTop: -25
                    }} />
                </div>
            }
            {!loaded && !isClientMessage &&
                <div className='column is-offset-1 is-10'>
                    <div className='skeleton' style={{
                        width: '100%',
                        height: 190,
                        marginTop: -25
                    }} />
                </div>
            }
        </div>)
}

Message.propTypes = {
    message: PropTypes.object,
    loaded: PropTypes.bool,
    senderName: PropTypes.string,
    isClientMessage: PropTypes.bool
}

export default Message